// extracted by mini-css-extract-plugin
export default {"form":"Form_form__2c9Qi","form__submit":"Form_form__submit__eruFD","form__secondary":"Form_form__secondary__mA9VT"};